/**
 * Capacity
 */
export class Capacity {
  /**
   * id
   */
  id: number;

  /**
   *  type
   */
  type: string;

  /**
   * description
   */
  description: string;

  /**
   * value
   */
  value: number;

  /**
   * definition
   */
  definition: string;

  /**
   * active
   */
  active: boolean;

  /**
   * slots
   */
  slots: boolean;

  /**
   * Create instance from JSON
   *
   * @param json Object
   *
   * @returns Capacity instance
   */
  static createFromJson(json: object): Capacity {
    const self = new this();

    Object.keys(json).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }
}
